import { getServerProps } from '../utils/serverProps';
import _map from 'lodash/map';

const defaultState = {
	...getServerProps(),
	receivableCurrency: _map(getServerProps().receivableCurrency, (currency) => {
		return {
			value: currency,
			displayValue: currency
		}
	})
};

export default function application(state = defaultState, action) {
	switch (action.type) {
		default: return state;
	}
}



// WEBPACK FOOTER //
// ./buttons/reducers/reducerApplication.js